import { VIcon } from 'vuetify/lib/components/VIcon';
import Ripple from 'vuetify/lib/directives/ripple';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      directives: [{ def: Ripple, name: "ripple", rawName: "v-ripple" }],
      staticClass:
        "lpu-cards-filters-nav-item d-flex align-center ga-4 px-4 py-2",
      attrs: { "data-qa": _vm.itemDataQa },
      on: {
        click: function ($event) {
          return _setup.emit("click")
        },
      },
    },
    [
      _c(VIcon, { attrs: { size: "24", color: "icon-secondary" } }, [
        _vm._v("\n    " + _vm._s(_vm.icon) + "\n  "),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "d-flex flex-column flex-grow-1 min-w-0" }, [
        _c("div", { staticClass: "text-body-1 text--text" }, [
          _vm._v("\n      " + _vm._s(_vm.title) + "\n    "),
        ]),
        _vm._v(" "),
        _vm.subtitle
          ? _c("div", { staticClass: "text-body-2 text-secondary--text" }, [
              _vm._v("\n      " + _vm._s(_vm.subtitle) + "\n    "),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c(VIcon, { attrs: { size: "24", color: "icon-secondary" } }, [
        _vm._v("\n    ui-icon-arrow-right\n  "),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }